import moment from 'moment';
import { NO_EXPIRY_DATE_ISO, NO_EXPIRY_DAY } from '@/config/constants';

export { NO_EXPIRY_DATE_ISO, NO_EXPIRY_DAY };

export function isNoExpiryDate(date?: string | Date | null): boolean {
  if (!date) {
    return false;
  }
  const d = new Date(date);
  const sentinel = new Date(NO_EXPIRY_DATE_ISO);
  if (Number.isNaN(d.getTime()) || Number.isNaN(sentinel.getTime())) {
    return false;
  }
  const isSameYmd = (
    year: number, month: number, day: number,
    otherYear: number, otherMonth: number, otherDay: number,
  ) => year === otherYear && month === otherMonth && day === otherDay;
  return isSameYmd(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), sentinel.getUTCFullYear(), sentinel.getUTCMonth(), sentinel.getUTCDate())
    || isSameYmd(d.getFullYear(), d.getMonth(), d.getDate(), sentinel.getFullYear(), sentinel.getMonth(), sentinel.getDate());
}

export function resolveExpirationDateFromDay(
  expirationDay?: number | string | null,
  storageDate?: string,
): string {
  const day = Number(expirationDay);
  if (day === NO_EXPIRY_DAY) {
    return NO_EXPIRY_DATE_ISO;
  }
  if (!day || Number.isNaN(day) || !storageDate) {
    return '';
  }
  return new Date(new Date(storageDate).getTime() + day * 24 * 60 * 60 * 1000).toISOString();
}

/**
 * 使用moment.js格式化日期时间
 * @param date 要格式化的日期时间
 * @param format 输出格式，默认为'YYYY-MM-DD HH:mm:ss'
 * @returns 格式化后的日期时间字符串
 */
export function formatDateTime(date: Date | string | number, format: string = 'YYYY-MM-DD HH:mm:ss'): string {
  let newDate: Date;
  // 如果传入的是字符串且不包含 'T'（说明可能不是 ISO 格式），则尝试转换
  if (typeof date === 'string' && date.includes(' ') && !date.includes('T')) {
    // 将空格替换为 'T' 并追加 'Z'，确保格式满足 ISO 格式
    newDate = new Date(date.replace(' ', 'T') + 'Z');
  } else {
    newDate = new Date(date);
  }

  const isoDate = newDate.toISOString();

  return moment(isoDate).format(format);
}
